// This icon file is generated automatically.
var PHighlightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.96 6.93L8.42 1.47a.12.12 0 00-.17 0L4.52 5.15a.13.13 0 000 .17l.63.62-1.84 1.8a.13.13 0 000 .18l.62.6-2.95 2.93H.13a.13.13 0 00-.13.13v.86c0 .07.06.12.13.12H5.5c.04 0 .07-.01.1-.03l1.18-1.18.63.62c.05.05.13.05.18 0l1.83-1.8.62.6c.05.06.13.06.18 0l3.73-3.67a.12.12 0 000-.17zM5.1 11.44H2.6l2.1-2.08 1.25 1.24-.85.84zm2.42-.97L4.83 7.83 5.9 6.78 8.58 9.4l-1.07 1.06zm2.63-1.19l-4.1-4.04 2.3-2.27 4.1 4.05-2.3 2.26z", "fill-rule": "nonzero" } }] }, "name": "p-highlight", "theme": "outlined" };
export default PHighlightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PHighlightOutlined.js
// module id = 3453
// module chunks = 0